<template>
  <div>
    <van-nav-bar
      title=""
      right-text="退出"
      left-arrow
      :placeholder="navPlaceholder"
      :fixed="navFixed"
      @click-left="onClickLeft"
      @click-right="logout"
    />
    <div style="width: 100%;align-content: center;text-align: center">{{ address_name }}</div>
    <div class="tableSearchBox">
      <el-date-picker
        v-model="between_day_start"
        type="month"
        placeholder="开始日期"
        style="margin-right: 1%"
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        搜索
      </el-button>
    </div>
    <div class="tableBox">
      <el-table
        :data="tableData"
        style="width: 100%;"
        :border="isBorder"
      >
        <template v-if="tableData.length === 0" slot="empty">
          <p>暂无数据</p>
        </template>
        <template v-else>
          <el-table-column label="货品信息">
            <template slot-scope="{row}">
              <el-form v-if="row.table_delivery_goods.length !== 0" inline class="demo-table-expand">
                <div v-for="(item,index) in row.table_delivery_goods" :key="index">
                  <el-form-item :label="item.goods_name">
                    <span style="font-weight: bold">{{ item.goods_num }}</span>
                  </el-form-item>
                </div>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="发货日期" align="center">
            <template slot-scope="{row}">
              <!--              <span>{{ row.create_time }}</span>-->
              <span>{{ toParseTime(row.send_day, '{y}-{m}-{d}') }}</span>
              <br>
              <span>{{ toParseTime(row.send_day, '{h}:{i}:{s}') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="签收人" align="center">
            <template slot-scope="{row}">
              <span>{{ row.sign_name }}</span>
            </template>
          </el-table-column>
          <!--          <el-table-column label="收货地址" align="center">-->
          <!--            <template slot-scope="{row}">-->
          <!--              <span>{{ row.customer.area_name }} - {{ row.customer.address_name }}</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </template>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        small
        :pager-count="5"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </div>
    <div class="addButton">
      <el-button style="width: 60%" type="primary" @click="handleCreate">添加</el-button>
    </div>
    <el-dialog class="abow_dialog" title="添加" :visible.sync="dialogFormVisible">
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="left"
        label-width="70px"
        style="width: 400px; margin-left:50px;"
      >
        <el-form-item v-if="options.length !== 0" label="添加商品">
          <el-select ref="select" v-model="goods" clearable placeholder="请选择商品" @change="onAdd(goods)">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.goods_name"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="发货时间" prop="send_day">
          <el-date-picker v-model="temp.send_day" type="datetime" placeholder="请选择时间" />
        </el-form-item>
        <template v-if="dynamicValidateForm.length !== 0">
          <el-form-item
            v-for="(domain) in dynamicValidateForm"
            :key="domain.id"
            :label="domain.goods_name"
          >
            <el-input v-model="domain.value" type="number" style="width: 80px;margin-right: 1%" />
            <el-button @click.prevent="removeDomain(domain)">删除</el-button>
          </el-form-item>
        </template>
        <el-form-item label="签收人" prop="area_name">
          <el-input v-model="sign_name" style="width: 13.5rem;margin-right: 1%" />
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="createData">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { List, NavBar, Toast } from 'vant'
import { getOrderList, getGoodsList, getCooperativesList, addOrder } from '@/api/user'
import { parseTime } from '@/utils'
import user from '@/store/modules/user'
import Pagination from '@/components/Pagination' // secondary package based on el-pagination
export default {
  name: 'Table',
  components: {
    Pagination,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [Toast.name]: Toast
  },
  data: function() {
    return {
      total: 0,
      tableData: [],
      container: null,
      navFixed: true,
      navPlaceholder: true,
      between_day_start: '',
      between_day_end: '',
      isBorder: true,
      isFit: true,
      listQuery: {
        page: 1,
        currentPage: 1,
        limit: 0
      },
      sign_name: '',
      dialogFormVisible: false,
      rules: {
        type: [{ required: true, message: 'type is required', trigger: 'change' }],
        timestamp: [{ type: 'date', required: true, message: 'timestamp is required', trigger: 'change' }],
        title: [{ required: true, message: 'title is required', trigger: 'blur' }]
      },
      temp: {
        send_day: new Date()
      },
      options: [],
      dynamicValidateForm: [],
      goods: [],
      users: [],
      user: []
    }
  },
  created() {
    this.address_id = this.$route.query.id
    this.address_name = this.$route.query.name
    // console.log(this.$route.query)
    this.getList()
  },
  methods: {
    handleCurrentChange() {
      this.getList()
    },
    logout() {
      this.$store.dispatch('user/logout')
      this.$router.push('/login')
    },
    onClickLeft() {
      this.$router.push({ path: this.redirect || '/driver/area' })
    },
    resetTemp() {
      this.dynamicValidateForm = []
      this.temp = {
        send_day: new Date()
      }
    },
    toParseTime(data, type) {
      console.log(data)
      return parseTime(data, type)
    },
    // 添加商品
    onAdd(data) {
      // console.log(data)
      this.goods = null
      data.value = ''
      if (this.dynamicValidateForm.length !== 0) {
        for (const item in this.dynamicValidateForm) {
          if (this.dynamicValidateForm[item].id === data.id) {
            return
          }
        }
      }
      this.dynamicValidateForm.push({
        id: data.id,
        goods_name: data.goods_name,
        value: ''
      })
    },
    // 删除商品
    removeDomain(item) {
      var index = this.dynamicValidateForm.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.splice(index, 1)
      }
    },
    changeDynamicValidateForm(item) {
      // const list = Object.assign({}, data)

      if (item.length === 0) {
        this.$message.error('至少添加一个商品')
      }
      const arr = []
      for (const key in item) {
        arr.push({
          'goods_id': item[key].id,
          'goods_num': item[key].value
        })
      }

      return arr
    },
    handleFilter() {
      if (this.between_day_start) {
        const date = this.between_day_start
        this.between_day_start = parseTime(date, '{y}-{m}-{d} 0:0:0')
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
        // 本月最后一天
        this.between_day_end = parseTime(lastDay, '{y}-{m}-{d} 23:59:59')
        this.getList()
      } else {
        this.$notify({
          // title: '成功',
          message: '请选择时间',
          type: 'error',
          duration: 2000
        })
        this.between_day_start = null
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogFormVisible = true
      const data = Object.assign({})
      data.is_all = 1
      getGoodsList(data).then(response => {
        this.options = response.data.list
      })

      data.address_id = this.address_id
      getCooperativesList(data).then(response => {
        this.users = response.data.list
        this.getList()
      })
    },
    createData() {
      const arr = this.changeDynamicValidateForm(this.dynamicValidateForm)
      const queryList = Object.assign({}) // copy obj
      queryList.sign_name = this.sign_name
      queryList.goods = JSON.stringify(arr)
      queryList.send_day = parseTime(new Date())
      queryList.address_id = this.$route.query.id
      addOrder(queryList).then(() => {
        this.dialogFormVisible = false
        this.$notify({
          // title: '成功',
          message: '添加成功',
          type: 'success',
          duration: 2000
        })
        this.getList()
      })
    },
    getList() {
      const data = Object.assign({
        page: this.listQuery.page,
        address_id: this.address_id
      })
      if (this.between_day_start && this.between_day_end) {
        data.between_day = this.between_day_start + ',' + this.between_day_end
      }
      getOrderList(data).then(response => {
        this.total = response.data.list.total
        this.listQuery.limit = response.data.list.per_page
        this.tableData = response.data.list.data
      })
    }
  }
}
</script>

<style scoped>
    .tableSearchBox {
        padding: 3% 3%;
    }
    .dialog-footer{
      text-align: center
    }
    .tableBox {
        padding: 3% 3%;
        margin-bottom: 10rem;
    }
  .abow_dialog{
    overflow-y:auto;
  }
</style>
<style>
    .el-dialog {
        width: 25rem;
    }

    .el-table__expanded-cell[class*=cell] {
        padding: 0 3%;
    }

    .el-dialog__wrapper {
        overflow: hidden;
    }

    .demo-table-expand {
        font-size: 0;
        padding: 0;

    }

    .demo-table-expand label {
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        float: left;
        margin-right: 0;
        margin-bottom: 0;
        width: 5rem;
    }

    .addButton {
        /*position: absolute;*/
        position: fixed;
        bottom: 0;
        display: table-cell;
        text-align: center;
        vertical-align: middle;
        width: 100%;
        height: 6rem;
        background: #FFFFFF;
    }
</style>
